//@ts-check
import project from './project';
import projectUid from './projectUid';
import projectName from './projectName';
import correspondence from './correspondence';
import projectTemplate from './projectTemplate';
import projectDependency from './projectDependency';
import communication from './communication';
import communicationOutput from './communicationOutput';
import communicationRun from './communicationRun';
import systemAnalytics from './systemAnalytics';
import systemAnalyticsStatus from './systemAnalyticsStatus';
/** @type {import('../types').DataTypesConfig}*/

var TYPES = {
  project: project,
  projectUid: projectUid,
  projectName: projectName,
  correspondence: correspondence,
  projectDependency: projectDependency,
  projectTemplate: projectTemplate,
  systemAnalytics: systemAnalytics,
  systemAnalyticsStatus: systemAnalyticsStatus,
  communication: communication,
  communicationOutput: communicationOutput,
  communicationRun: communicationRun
};
export default TYPES;